module.exports = __webpack_public_path__ + "img/fb18.cb8a7035.jpg";